<template>
    <div>
        <Form @submit="submit">
            <Field
                    v-model="handleMethodName"
                    label="处理方式"
                    required
                    readonly
                    clearable
                    @click="selectShow=true"
                    placeholder="请选择处理方式"
                    right-icon="arrow-down"
                    :rule="[{required:true,message:'请选择处理方式'}]"
            />
            <Field
                    v-model="orders.handleRemark"
                    label="处理意见"
                    clearable
                    required
                    placeholder="请输入处理意见"
                    :rule="[{required:true,message:'请输入处理意见'}]"
            />
            <div style="display:flex;justify-content : space-between;width:75%;margin:auto;">
                <UploadImage
                        :imageList="image1"
                        style="margin-top:5px;margin-left:-15px"
                        top="照片1"
                        type="WorkOrderImage"
                        @imageChange="image1Change"
                        :count="1"
                        edit
                />
                <UploadImage
                        :imageList="image2"
                        style="margin-top:5px;margin-left:-15px"
                        top="照片2"
                        type="WorkOrderImage"
                        @imageChange="image2Change"
                        :count="1"
                        edit
                />
                <UploadImage
                        :imageList="image3"
                        style="margin-top:5px;margin-left:-15px"
                        top="照片3"
                        type="WorkOrderImage"
                        @imageChange="image3Change"
                        :count="1"
                        edit
                />
                <UploadImage
                        :imageList="image4"
                        style="margin-top:5px;margin-left:-15px"
                        top="照片4"
                        type="WorkOrderImage"
                        @imageChange="image4Change"
                        :count="1"
                        edit
                />
            </div>
            <Button type="info" block class="fixed-bottom-button" native-type="submit">保存</Button>
            <SelectDict dictKey="ORDER_TSAK_HANDLE_METHOD" :show="selectShow"
                        @cancel="selectShow=false" @ok="onMethodOk"/>
        </Form>
    </div>
</template>

<script>
    import {Button, Cell, CellGroup, Dialog, Field, Form} from "vant"
    import SelectDict from "@/components/SelectPopup/SelectDict";
    import UploadImage from "@/components/UploadImage"
    import {mapGetters} from "vuex";

    export default {
        components: {Dialog, Cell, CellGroup, SelectDict, Button, Form, Field, UploadImage},
        props: {},
        data() {
            return {
                orders: {
                    id: this.$route.params.id,
                    handleMethod: [],
                    handleRemark: null,
                    image1: null,
                    image2: null,
                    image3: null,
                    image4: null,
                },
                handleMethodName: null,
                selectShow: false,
            }
        },
        computed: {
            ...mapGetters({position: 'wechat/position'}),
            image1() {
                return this.orders.image1 ? [this.orders.image1] : []
            },
            image2() {
                return this.orders.image2 ? [this.orders.image2] : []
            },
            image3() {
                return this.orders.image3 ? [this.orders.image3] : []
            },
            image4() {
                return this.orders.image4 ? [this.orders.image4] : []
            },
        },
        created() {
        },
        mounted() {
        },
        methods: {
            onCancel() {
                this.selectShow = false;
            },
            submit() {
                this.orders.handleLat = this.position.longitude;
                this.orders.handleLng = this.position.latitude;
                this.$toast.loading("正在处理中...")
                this.$http.tokiot.order.task.submit(this.orders)
                    .then(res => {
                        if (res) {
                            this.$toast.success("处理成功")
                            setTimeout(() => {
                                this.$router.history.go(-1);
                            }, 500);
                        } else {
                            this.$toast.fail(res.message)
                        }
                    })
            },
            image1Change(imageList) {
                this.orders.image1 = imageList[0];
            },
            image2Change(imageList) {
                this.orders.image2 = imageList[0];
            },
            image3Change(imageList) {
                this.orders.image3 = imageList[0];
            },
            image4Change(imageList) {
                this.orders.image4 = imageList[0];
            },
            onMethodOk(data) {
                this.handleMethodName = data.codeName;
                this.orders.handleMethod = data.code;
                this.selectShow = false;
            },
        },
        watch: {}
    }
</script>

<style scoped>
    .fixed-bottom-button {
        position: fixed;
        margin-left: 8px;
        bottom: 8px;
        width: calc(100% - 16px);
    }

</style>